const initialKeywordState = {
  serp: null,
  history: null,
  focusSerpFeature: null,
  focusSerpFeatureDomainId: null,
  focusSerpFeatureKeywordId: null,
  error: false
}

const getKeywordsWithNewKeyword = (keywords, newKeywordId) => {
  return Object.assign({}, keywords, {
    [newKeywordId]: {
      ...initialKeywordState
    }
  })
}

export default getKeywordsWithNewKeyword
